import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import CartContents from './CartContents';
import CartVoucherItems from './CartVoucherItems';
import OrderSummary from './OrderSummary';
import NewOrder from './NewOrder';
import KeepShoppingButton from './KeepShoppingButton';
import { resetAdditionalData } from '../../../actions/additionalData';
import cartUtils from '../../../utils/cart';
import { removeCartItem } from '../../../actions/v3Order/v3Order';
import { isShippingRestrictedForParent } from '../helpers/internationalRestriction';

const CartHeader = styled.h4`
  margin: 0;
  font-size: 24px;
`;

const CartDivider = styled.hr`
  margin: 12px 0 20px 0;
  border-top: 1px solid #ddd;
`;

const CartList = styled.ul`
  @media (max-width: 767px) {
    padding: 0;
  }
`;

const Cart = ({ history }) => {
  const dispatch = useDispatch();

  const orders = useSelector((state) => state.v3Order.orders);
  const company = useSelector((state) => state.company);
  const cartVoucherItems = useSelector((state) => state.cartVoucherItems);
  const shoot = useSelector((state) => state.shoot?.shoot);
  const parent = useSelector((state) => state.parent);
  const country = parent?.address?.country || 'US';
  const restricted = isShippingRestrictedForParent(shoot, parent);

  const hasRegularProducts = !cartUtils.allOrdersAreEmpty(orders);
  const allVoucherItems = cartVoucherItems.items || [];
  const unassignedVoucherItems = allVoucherItems.filter(
    (item) => !item.order_key,
  );
  const hasAnyVouchers = allVoucherItems.length > 0;

  // When regular products exist, order-keyed vouchers appear under their StudentOrder.
  // When no regular products exist, show all vouchers in the cart-wide section so
  // order-keyed items remain visible and removable.
  const cartWideVoucherItems = hasRegularProducts
    ? unassignedVoucherItems
    : allVoucherItems;
  const hasCartWideVouchers = cartWideVoucherItems.length > 0;

  useEffect(() => {
    if (!hasRegularProducts && !hasAnyVouchers) {
      // dispatch(resetAdditionalData());
      history.push('/v3/offers');
    }
  }, [
    orders,
    cartVoucherItems.items,
    history,
    hasRegularProducts,
    hasAnyVouchers,
  ]);

  const incentiveProducts = useSelector(
    (state) => state.shoot?.incentiveProducts,
  );

  useEffect(() => {
    if (!restricted) return;
    const toRemove = cartUtils.removableShippingIncentives(
      orders,
      country,
      incentiveProducts,
    );
    toRemove.forEach(({ orderKey, cartItemId }) => {
      dispatch(removeCartItem(cartItemId, orderKey));
    });
  }, [restricted, orders, country, dispatch, incentiveProducts]);

  return (
    <div className="bnl-order-cart">
      <CartHeader>Your Cart</CartHeader>
      <CartDivider />
      <div className="bnl-order-cart-container row">
        <CartList className="bnl-order-cart__content col-xs-12 col-md-8 col-lg-8">
          {hasRegularProducts && <CartContents orders={orders} />}
          {hasCartWideVouchers && (
            <CartVoucherItems items={cartWideVoucherItems} />
          )}
        </CartList>
        <div className="bnl-order-cart__right col-xs-12 col-md-4 col-lg-4 clearfix">
          <OrderSummary orders={orders} />
          <NewOrder company={company} />
          <KeepShoppingButton />
        </div>
      </div>
    </div>
  );
};

export default Cart;
